export default {
  meta: {
    title: '销售目标',
    url: '/intelligent/sales',
    parentPath: ['/intelligent'],
    breadcrumbs: {
      path: ['/intelligent/sales'],
      name: ['销售目标'],
    },
  }
};
